module.exports = __webpack_public_path__ + "static/media/shopping-basket.c246749f.svg";